<template>
  <div>
    <new-room-dialog :state="newDialog" />
    <room-update-dialog :state="editDialog" :room="selected" />
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs
          headline="Dach sách phòng học"
          :link="[{ text: 'Danh sách lớp', href: '../Rooms' }]"
        />
      </div>
      <div>
        <v-btn color="primary" @click="newDialog = !newDialog" v-if="canEditRoom"
          ><v-icon left>add</v-icon>{{ addButtonText }}</v-btn
        >
      </div>
    </div>
    <v-card class="pa-2 mx-md-2">
      <v-data-table
        item-key="id"
        :headers="headers"
        :items="rooms"
        sort-by="createdAt"
        :sort-desc="true"
      >
        <template v-slot:[`item.actions`]="{ item }" v-if="canEditRoom">
          <room-list-actions :selected="item" @onEdit="editRoom" />
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import RoomListActions from '@/modules/room/RoomListActions'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import NewRoomDialog from '@/modules/room/NewRoomDialog'
import RoomUpdateDialog from '@/modules/room/RoomUpdateDialog'

export default {
  components: {
    RoomListActions,
    Breadcrumbs,
    NewRoomDialog,
    RoomUpdateDialog
  },
  props: {
    role: String
  },
  data() {
    return {
      headers: [
        {
          text: 'Tên phòng học',
          value: 'title',
          align: 'left',
          sortable: false
        },
        { text: 'Mô Tả', value: 'notes', align: 'left', sortable: false },
        { text: 'Hành động', value: 'actions', align: 'left', sortable: false }
      ],
      selected: {},
      draw: false,
      search: '',
      status: null,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' }
      ],
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      roomTableOptions: {},
      newDialog: false,
      editDialog: false
    }
  },
  async created() {
    this.fetchRooms({ department: this.department.id })
  },
  computed: {
    ...mapState('app', ['department']),
    ...mapGetters('rooms', ['rooms']),
    ...mapGetters('auth', ['role']),
    canEditRoom() {
      return ['education_manager', 'super_admin'].includes(this.role.type)
    },

    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm phòng học'
      }
    }
  },
  methods: {
    ...mapActions('rooms', ['fetchRooms']),
    updateDraw(draw) {
      this.draw = draw
    },
    onRoomSelected(room) {
      this.setRoom(room)
      this.draw = true
    },
    editRoom(data) {
      this.selected = data
      this.editDialog = !this.editDialog
    }
  }
}
</script>
